import { combineReducers } from 'redux';
import execute, * as fromExecute from './execute';
import metainf, * as fromMetainf from './metainf';
import manual, * as fromManual from './manual';
import compose, * as fromCompose from './compose';

export default combineReducers({
  execute,
  metainf,
  manual,
  compose,
});

export const getExecutionEvents = (state) => fromExecute.getEvents(state.execute);

export const getEventsExecuteTime = (state) => fromExecute.getExecuteTime(state.execute);

export const getEventsOptions = (state) => fromExecute.getEventsOptions(state.execute);

export const isExecuting = (state) => fromExecute.isExecuting(state.execute);

export const getExecuteId = (state) => fromExecute.getExecuteId(state.execute);

export const getMetainf = (state, event) => fromMetainf.getMetainf(state.metainf, event);

export const getEventNames = (state) => fromMetainf.getEventNames(state.metainf);

export const getFieldPathsFor = (state, entry) =>
  fromMetainf.getFieldPathsFor(state.metainf, entry);

export const getFieldPathKeys = (state) => fromMetainf.getFieldPathKeys(state.metainf);

export const isMetainfFetching = (state) => fromMetainf.isFetching(state.metainf);

export const getManualCode = (state) => fromManual.getCode(state.manual);

export const getIds = (state) => fromCompose.getIds(state.compose);

export const getGroupColumn = (state) => fromCompose.getGroupColumn(state.compose);

export const getSql = (state, id) => fromCompose.getSql(state.compose, id);

export const getError = (state, id) => fromCompose.getError(state.compose, id);

export const getName = (state, id) => fromCompose.getName(state.compose, id);

export const getUniqueChar = (state, id) => fromCompose.getUniqueChar(state.compose, id);

export const getPeriodsState = (state, id) => fromCompose.getPeriodsState(state.compose, id);

export const getFilter = (state, id) => fromCompose.getFilter(state.compose, id);

export const getAggregationColumn = (state, id) =>
  fromCompose.getAggregationColumn(state.compose, id);

export const getAggregationType = (state, id) => fromCompose.getAggregationType(state.compose, id);

export const getSplitColumn = (state, id) => fromCompose.getSplitColumn(state.compose, id);

export const getEvents = (state) => fromCompose.getEvents(state.compose);

export const getIdUsingTemplate = (state) => fromCompose.getIdUsingTemplate(state.compose);

export const getEventsCsv = (state) => fromCompose.getCsv(state.compose);

export const getOthersFilter = (state, id) => fromCompose.getOthersFilter(state.compose, id);
